
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as addSWAT2jlVu1gEBT_8bXpCLm9BX6Lq04zu51YtkRIH1IEMeta } from "/opt/build/repo/pages/add.vue?macro=true";
import { default as indexaAs6F0uOO1PbNxqH8DD_e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as meetupL3kySkCicqDvAQVAZqfmRlWLioQWZZAnfSprxuf0hQ0Meta } from "/opt/build/repo/pages/meetup.vue?macro=true";
import { default as memberR40RKWlK3UNg_wxC_YCFGje_wWadfHZJh0oXBy_DzcsMeta } from "/opt/build/repo/pages/member.vue?macro=true";
import { default as explore4A2m30c7pzE2npK3xi3dh1Ggau6m_TB_JfsUxX14WrcMeta } from "/opt/build/repo/pages/explore.vue?macro=true";
import { default as thankyouYTB0wx8a0lhFH6nJhR1hGp9JE0RF2kCcak1sQivByTkMeta } from "/opt/build/repo/pages/thankyou.vue?macro=true";
import { default as add_45alert2QnufCY1OzrTwUoDq1MS7yLxj1lhwF7rzJWBsn1kqvoMeta } from "/opt/build/repo/pages/add-alert.vue?macro=true";
import { default as _91id_93hoRdv_WaYYmKe9RAce6hUE5QxDFt4e9BWXpWwtHKaTcMeta } from "/opt/build/repo/pages/buzz/[id].vue?macro=true";
import { default as loginC2_RyArbDc1V5VgcbohZHLcovvvIu2SbApdwX_CbhI8Meta } from "/opt/build/repo/pages/auth/login.vue?macro=true";
import { default as indexCHDzYbUnHcqtJy88awlFscmusNrOqq6TnGIeZANkc_sMeta } from "/opt/build/repo/pages/buzz/index.vue?macro=true";
import { default as indexQYBbwqmeFTKzOeFn46eoFndAdLwT1cl0WWM2kbgbDLcMeta } from "/opt/build/repo/pages/about/index.vue?macro=true";
import { default as termsNzRur2Na9Cz5B8HK3S1uw4rAhVLQ_MFSsMN3sUu904oMeta } from "/opt/build/repo/pages/about/terms.vue?macro=true";
import { default as signupvNzOrQCGe64_dJrEMVVW8_ESsgzTQblDREajegOJFqgMeta } from "/opt/build/repo/pages/auth/signup.vue?macro=true";
import { default as _91id_93pXtxyHZUUD8ihFlCFjuv4Kx1ckkp1PF9j3Y0FQ3ah14Meta } from "/opt/build/repo/pages/events/[id].vue?macro=true";
import { default as _91id_93Y4Sx65vvyjRdrh6k7medMiL1B55MPcsDWPAFZcnBJNgMeta } from "/opt/build/repo/pages/people/[id].vue?macro=true";
import { default as _91id_93VGiTsWt3YWLFfulMbU1oV9mymY8a2OVRKi4baO7WtpsMeta } from "/opt/build/repo/pages/poster/[id].vue?macro=true";
import { default as memberF5n22sPSVrdcG6sDmfzcSUXMFZHOAOQwy2Ycpg1ouSEMeta } from "/opt/build/repo/pages/about/member.vue?macro=true";
import { default as indexEVOP_aPKk8sfXL_UWlkpAKz5s9qe74EITg8TTFzJMA4Meta } from "/opt/build/repo/pages/events/index.vue?macro=true";
import { default as indexloAEjyGKNNxrmtH8__TqCIv_Jsuv7LR19KyUtTw_FPwMeta } from "/opt/build/repo/pages/people/index.vue?macro=true";
import { default as _91id_932Eb_D6xaYuf0sOMB1DRUorDOtQksIgDfszrtg6dmsVkMeta } from "/opt/build/repo/pages/profile/[id].vue?macro=true";
import { default as contactgl9JVmpKtotmQIdDpg3Kq50Wrgzlpzu_ITex1zqjGPEMeta } from "/opt/build/repo/pages/about/contact.vue?macro=true";
import { default as become_45a_45memberv1jAHuS_Gax6f_7GjIeB3_ZenU5JrtcHjJfQiqyjOYEMeta } from "/opt/build/repo/pages/become-a-member.vue?macro=true";
import { default as index8xoVnVnRZ_kyMH7QwvT3ZfFyN62Xk1mA8ppzVlBL6wkMeta } from "/opt/build/repo/pages/dashboard/index.vue?macro=true";
import { default as profilekUwpN8YDRdzkm1bqul5BHYcSeLwtiyH_3AYMNcg7sP4Meta } from "/opt/build/repo/pages/dashboard/profile.vue?macro=true";
import { default as settingskIjGwfCmun1i8R86PjHAb5azVkiGfohvSb8l72CyBZ0Meta } from "/opt/build/repo/pages/dashboard/settings.vue?macro=true";
import { default as indexGQZXjvtXiZPflX7XgEfRw05dN2LGkPBYN0iMY4LoeosMeta } from "/opt/build/repo/pages/dashboard/events/index.vue?macro=true";
import { default as createpFcvn8UoXwRgL63WcalOlNQLzGDVQqH1qn4L_sJOxF4Meta } from "/opt/build/repo/pages/dashboard/events/create.vue?macro=true";
export default [
  {
    name: "add",
    path: "/add",
    component: () => import("/opt/build/repo/pages/add.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "meetup",
    path: "/meetup",
    component: () => import("/opt/build/repo/pages/meetup.vue")
  },
  {
    name: "member",
    path: "/member",
    component: () => import("/opt/build/repo/pages/member.vue")
  },
  {
    name: "explore",
    path: "/explore",
    component: () => import("/opt/build/repo/pages/explore.vue")
  },
  {
    name: "thankyou",
    path: "/thankyou",
    component: () => import("/opt/build/repo/pages/thankyou.vue")
  },
  {
    name: "add-alert",
    path: "/add-alert",
    component: () => import("/opt/build/repo/pages/add-alert.vue")
  },
  {
    name: "buzz-id",
    path: "/buzz/:id()",
    component: () => import("/opt/build/repo/pages/buzz/[id].vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/opt/build/repo/pages/auth/login.vue")
  },
  {
    name: "buzz",
    path: "/buzz",
    component: () => import("/opt/build/repo/pages/buzz/index.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/build/repo/pages/about/index.vue")
  },
  {
    name: "about-terms",
    path: "/about/terms",
    component: () => import("/opt/build/repo/pages/about/terms.vue")
  },
  {
    name: "auth-signup",
    path: "/auth/signup",
    component: () => import("/opt/build/repo/pages/auth/signup.vue")
  },
  {
    name: "events-id",
    path: "/events/:id()",
    component: () => import("/opt/build/repo/pages/events/[id].vue")
  },
  {
    name: "people-id",
    path: "/people/:id()",
    component: () => import("/opt/build/repo/pages/people/[id].vue")
  },
  {
    name: "poster-id",
    path: "/poster/:id()",
    component: () => import("/opt/build/repo/pages/poster/[id].vue")
  },
  {
    name: "about-member",
    path: "/about/member",
    component: () => import("/opt/build/repo/pages/about/member.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/opt/build/repo/pages/events/index.vue")
  },
  {
    name: "people",
    path: "/people",
    component: () => import("/opt/build/repo/pages/people/index.vue")
  },
  {
    name: "profile-id",
    path: "/profile/:id()",
    component: () => import("/opt/build/repo/pages/profile/[id].vue")
  },
  {
    name: "about-contact",
    path: "/about/contact",
    component: () => import("/opt/build/repo/pages/about/contact.vue")
  },
  {
    name: "become-a-member",
    path: "/become-a-member",
    component: () => import("/opt/build/repo/pages/become-a-member.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(index8xoVnVnRZ_kyMH7QwvT3ZfFyN62Xk1mA8ppzVlBL6wkMeta || {}), ...{"middleware":["authneeded"]} },
    component: () => import("/opt/build/repo/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-profile",
    path: "/dashboard/profile",
    meta: { ...(profilekUwpN8YDRdzkm1bqul5BHYcSeLwtiyH_3AYMNcg7sP4Meta || {}), ...{"middleware":["authneeded"]} },
    component: () => import("/opt/build/repo/pages/dashboard/profile.vue")
  },
  {
    name: "dashboard-settings",
    path: "/dashboard/settings",
    meta: { ...(settingskIjGwfCmun1i8R86PjHAb5azVkiGfohvSb8l72CyBZ0Meta || {}), ...{"middleware":["authneeded"]} },
    component: () => import("/opt/build/repo/pages/dashboard/settings.vue")
  },
  {
    name: "dashboard-events",
    path: "/dashboard/events",
    component: () => import("/opt/build/repo/pages/dashboard/events/index.vue")
  },
  {
    name: "dashboard-events-create",
    path: "/dashboard/events/create",
    component: () => import("/opt/build/repo/pages/dashboard/events/create.vue")
  }
]